// Single source of truth for subscription pricing copy across the web app.
// Premium is offered yearly ($15.99/yr) or monthly ($1.99/mo). Edit the atoms below
// and every page updates. The flat fields default to yearly for back-compat with
// pages that render a single price. These are list prices for new signups; what Stripe
// charges is whatever the STRIPE_PRICE_ID_* env vars point to, so change both together.
const yearly = {
  price: "$15.99",
  interval: "year",
  perInterval: "/year",
  priceWithInterval: "$15.99/year",
  monthlyEquivalent: "$1.33",
};

const monthly = {
  price: "$1.99",
  interval: "month",
  perInterval: "/month",
  priceWithInterval: "$1.99/month",
};

export const PRICING = {
  yearly,
  monthly,
  // Back-compat flat fields (default to yearly)
  price: yearly.price,
  interval: yearly.interval,
  perInterval: yearly.perInterval,
  priceWithInterval: yearly.priceWithInterval,
};

// The rate a subscriber actually pays, from the Stripe price on their subscription (amount in cents).
// Earlier subscribers keep their original price when list prices change, so never derive this from PRICING.
// Undefined when unknown, so callers never fall back to showing the wrong price.
export const subscriptionPriceLabel = (sub) => {
  if (sub?.amount == null || !sub?.interval) return undefined;
  const price = new Intl.NumberFormat("en-US", { style: "currency", currency: sub.currency || "usd" }).format(sub.amount / 100);
  return `${price}/${sub.interval}`;
};
